// extracted by mini-css-extract-plugin
export default {"container":"Scrollable-module__container--LHxfc","content":"Scrollable-module__content--dmAvm","arrows":"Scrollable-module__arrows--Q7NXO"};